namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeTaskListGridDialog extends Serenity.TemplatedDialog<UtentiProdottiEsperienzeTaskListGridOptions> {

        private checkGrid: UtentiProdottiEsperienzeTaskListGrid;

        constructor(opt: UtentiProdottiEsperienzeTaskListGridOptions) {
            super(opt);

            this.checkGrid = new UtentiProdottiEsperienzeTaskListGrid(this.byId("CheckGrid"), opt);
            this.dialogTitle = "";
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

    }
}